import { ENV } from '@hcs/webapps';

export const MIXPANEL_KEY =
  ENV === 'prod'
    ? '9ad2228e5ed1b283f90d5e7692a20288'
    : '28132cb5c4e38da79a54453961884895';
